import _ from 'lodash';
import User from 'Modules/currentUser/User';

import libUsers from 'lib/users';
import { USERS_RECEIVE, USERS_REQUEST, USERS_REQUEST_SUCCESS } from '../action-types';

export const receiveUser = (users) => ({
  type: USERS_RECEIVE,
  payload: {
    users: _.castArray(users),
  },
});

function getNotFoundUsers(foundUsers, allUsersIds) {
  return allUsersIds
    .filter((userId) => !foundUsers.some((user) => +user.id === +userId))
    .map((userId) => User.getAnonymousUser(userId));
}

export const requestUsers = (userIds) => {
  const userIdsArray = _.castArray(userIds);

  return (dispatch) => {
    const payload = {
      userIds: userIdsArray,
    };

    dispatch({
      type: USERS_REQUEST,
      payload,
    });

    // eslint-disable-next-line import/no-named-as-default-member
    return libUsers
      .fetch(userIdsArray)
      .then((users) => {
        let finalUsers = users;
        if (finalUsers.length !== userIdsArray.length) {
          finalUsers = finalUsers.concat(getNotFoundUsers(finalUsers, userIdsArray));
        }

        dispatch(receiveUser(finalUsers));
        dispatch({
          type: USERS_REQUEST_SUCCESS,
          payload,
        });
      })
      .catch((error) => {
        dispatch({
          type: USERS_REQUEST_SUCCESS,
          error,
        });
      });
  };
};
